<template>
    <v-server-table url="/api/admin/action-documents/table" :columns="columns" :options="options" class="trigger trigger-action-document" ref="table">
        <template slot="name" slot-scope="props">
            <router-link :to="{ name: 'admin.action-documents.view', params: { id: props.row.id }}" :style="nameColor(props.row.is_archived)">
                {{ props.row.name }}
                <small v-if="props.row.is_archived">
                    {{ uLang('app.archived') }}
                </small>
            </router-link>
        </template>
        <template slot="category" slot-scope="props">
            <b-badge pill variant="primary">{{ props.row.action_document_category.name }}</b-badge>
        </template>
        <template slot="blikOpWerk" slot-scope="props">
            <b-badge pill variant="primary">{{ props.row.bilk_op_werk_category?.value ?? '-' }}</b-badge>
        </template>

        <template slot="filter__blikOpWerk">
            <multi-select :options="blikOpWerks"
                            :selectLabel="''" :selectedLabel="uLang('app.select')"
                            label="value" :placeholder="uLang('app.select_an_option')" @input="searchBlikOpWerk"
                            track-by="id"/>
        </template>
    </v-server-table>
</template>

<script>
    import Actions from './actions'
    import { TableMixin } from '~/mixins'
    import MultiSelect from 'vue-multiselect'

    export default {
        name: 'index',
        mixins: [ TableMixin ],
        components: {
            'multi-select': MultiSelect,
        },
        mounted: function () {
            this.$refs.table.query.showArchived = false
        },
        created: function () {
            this.retrieveBlikOpWerks();
        },
        data () {
            return {
                columns: ['name', 'category','blikOpWerk', 'actions'],
                filterable: ['name', 'category'],
                templates: {
                    actions: Actions,
                },
                options: {
                    headings: {
                        name: this.uLang('app.name'),
                        category: this.uLang('app.template_category'),
                        blikOpWerk: "Blik Op Werk",
                        actions: this.uLang('app.actions'),
                    },
                    customFilters: [
                        'blikOpWerk',
                    ],
                    perPage: Number.parseInt(this.rowsPerPage, 10),
                },
                openToolTips: [],
                blikOpWerks: [],
            }
        },
        props: {
            showArchivedActionDocuments: {
                type: Boolean,
                default: false
            },
            rowsPerPage: {
                type: String,
                default: "15"
            }
        },
        methods: {
            nameColor(isArchived) {
                return isArchived ? 'color: #808080;' : ''
            },
            async retrieveBlikOpWerks() {
                const {data} = await window.axios.get(route('admin.settings.values.to_blik_op_werk'));
                this.blikOpWerks = data;
            },
            searchBlikOpWerk(item) {
                let itemId = item !== null ? item.id : '';
                this.$refs.table.query.blikOpWerkCategoryId = itemId;
                this.$refs.table.refresh();
            }
        },
        watch: {
            rowsPerPage(newValue) {
                this.$refs.table.setLimit(Number.parseInt(newValue, 10));
                this.$refs.table.refresh();
            },
            showArchivedActionDocuments(shouldShow) {
                this.$refs.table.query.showArchived = shouldShow
                this.$refs.table.refresh();
            }
        },
    }
</script>

<style lang="scss">

.trigger-action-document .VueTables__table {
    min-height: 300px;
}

</style>